module.exports = __webpack_public_path__ + "img/31.63278e8c.png";